<script>
import { formatTimestamp } from '../utils/formatTimestamp'
import { toDataUri } from '../../../helpers/toDataUri'
import NoData from '../common-components/table/NoData'

export default {
  name: 'MobilizeV2CampaignsTable',
  props: {
    value: { type: Array, required: false, default: () => [] }
  },
  components: {
    NoData
  },
  computed: {
    headers() {
      const headers = [
        {
          text: 'ID',
          sortable: true,
          value: 'id'
        },
        {
          text: 'Name',
          sortable: true,
          value: 'data.name'
        },
        { text: 'Created', value: 'createTime', sortable: true },
        { text: 'Last modified', value: 'updateTime', sortable: true }
      ]

      return headers
    },
    formatTimestamp() {
      return formatTimestamp
    },
    toDataUri() {
      return toDataUri
    },
    campaigns() {
      return this.$attrs.items
    }
  },
  inheritAttrs: false
}
</script>

<template>
  <v-data-table
    item-key="id"
    class="elevation-1"
    loading-text="Loading..."
    :headers="headers"
    :value="value"
    @input="$emit('input', $event)"
    v-bind="$attrs"
  >
    <template v-slot:[`item.id`]="{ item }">
      <router-link :to="'/mobilizev2/campaigns/' + item.id">
        {{ item.id }}
      </router-link>
    </template>
    <template v-slot:[`item.data.name`]="{ item }">
      <router-link :to="'/mobilizev2/campaigns/' + item.id">
        {{ item.data.name }}
      </router-link>
    </template>
    <template v-slot:[`item.createTime`]="{ item }">
      <span>{{ formatTimestamp(item.createTime) }}</span>
    </template>
    <template v-slot:[`item.updateTime`]="{ item }">
      <span>{{ formatTimestamp(item.updateTime) }}</span>
    </template>
    <template v-slot:no-data>
      <no-data dataType="campaign" link="/mobilizev2/campaigns/new" image="girl-clock.png" />
    </template>
  </v-data-table>
</template>

<style>
</style>
